import { useEffect, useState } from 'react';

/**
 * Collapsed state for the details-page summary cards.
 *
 * Folding is re-applied every time `shouldCollapse` turns true: activating the
 * fixture moves the tournament to IN_PROGRESS and refreshes it in place, and the
 * summaries are meant to get out of the fixture's way right then.
 *
 * Unfolding is never automatic. The status also flips on its own — loading the
 * last result finishes the tournament, the signup deadline starts it — and these
 * cards are several hundred px each, so re-expanding them would shove whatever the
 * manager is looking at down the page. Once open or closed by hand, it stays.
 */
export function useSummaryCollapse(shouldCollapse: boolean) {
  const [collapsed, setCollapsed] = useState(shouldCollapse);

  useEffect(() => {
    if (shouldCollapse) setCollapsed(true);
  }, [shouldCollapse]);

  return [collapsed, setCollapsed] as const;
}
